<template>
  <html>
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Instabill Pro</title>
      <link rel="icon" href="https://instabill.co/public/front/images/favicon.png">
    <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Jost:wght@400&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <!-- <link rel="stylesheet" type="text/css" href="https://instabill.co/public/pro/style.css"> -->
  <!-- <link rel="stylesheet" href="https://instabill.co/public/pro/animate.css"> -->
  </head>
  
  <body>
      <div class="menu-area navbar-fixed-top">
          <div class="container-fluid">
              <div class="row">
  
                  <!-- Navigation starts -->
                  <div class="col-md-12">
                      <div class="mainmenu">
                          <div class="navbar navbar-nobg">
                              <div class="navbar-header">
                                  <a class="navbar-brand" href="#">
                                      <img src="https://instabill.co/public/pro/instabillpro_logo.png" alt="">
                                  </a>
                                  <button type="button" v-on:click="showNavbar" class="navbar-toggle collapsed" data-toggle="collapse" data-target=".navbar-collapse">
                                      <span class="icon-bar"></span>
                                      <span class="icon-bar"></span>
                                      <span class="icon-bar"></span>
                                  </button>
                              </div>
  
                              <div class="navbar-collapse collapse1">
                                  <nav>
                                      <ul class="nav navbar-nav navbar-right">
                                          <li class="active"><a class="smooth_scroll" href="#slider">HOME</a></li>
                                          
                                          <li><a class="smooth_scroll" href="#pricing">PRICING</a></li>
                                        <li><a class="" href="https://pro.instabill.co/signIn" target="_blank">SIGN IN</a></li>
  
                                          <li class="sho"><a class="btn red-bg" href="https://pro.instabill.co/signup" target="_blank">SIGN UP</a></li>
                                          <li class="sho"> <router-link class="btn red-bg aa"  target="_blank" to="/bookdemo" style="background:linear-gradient(45deg,  rgba(102,204,153,1) 0%,rgba(108,205,148,1) 19%,rgba(136,209,125,1) 72%,rgba(146,211,117,1) 100%)">Book  Demo </router-link>  </li>
                                            <li class="sho bornder"><a class="btn red-bg aa" href="tel:+917982332316" style=""> Support +91 7982332316</a></li>
                                      </ul>
                                  </nav>
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- Navigation ends -->
  
              </div>
          </div>
      </div>
  <div class="ban">
    <div class="in_ban">
      <div class="left_a">
        <a href="" class="tally">GST & Tally Automation for Professionals</a>
        <h1>Let's Step Out Of Manual Accounting!</h1>
        <p>Instabill Pro is AI-powered Accounting Automation Software that reduces all your clerical work with 100% data accuracy.</p>
        <a href="https://pro.instabill.co/signup" target="_blank" class="start">Start 7-Days free trial</a><br>
        <span style="">No credit card required</span><br><br>
        <div class="bo">
          <span>Integrated With</span><br>
          <img src="https://instabill.co/public/pro/s_tally_logo.svg">
                  <img src="https://instabill.co/public/pro/gst.png" style="margin-left: 2%;">
                  <img src="https://instabill.co/public/pro/logo.png" style="    width: 130px;
      margin-left: 2%;">
      
        </div>
      </div>
      <div class="left_b">
        <img src="https://instabill.co/public/pro/img.png">
      </div>
    </div>
  </div>
  
  
  
  
  
  
  <div class="two">
      <div class="in_two">
          <h1>We are Trusted by <span>1000+</span> Tax Professionals & CA!</h1>
      </div>
  </div>
  
  <!-- <div class="eight">
      <div class="aa">
          <div class="ina">
              <span class="p1">Banking</span>
              <span class="p2">Sales</span>
              <span class="p3">GST Reconciliation</span>
              <span class="p4">Sales Return</span>
          <div class="in_right">
              <img src="https://instabill.co/public/instabillpro_logo.png">
          </div>
          <span class="p5">Purchase</span>
          <span class="p6">Purchase Return</span>
          <span class="p7">User Management</span>
          <span class="p8">CAGPT</span>
          </div>
      </div>
  </div> -->
  
  
  
  
  <div class="three">
      <div class="in_three">
          <h1>Accounting & Tax filing Made <br>not just Easy, but Automated.</h1>
          <p class="mm">Accurate, Reliable, and Hassle-Free!!</p>
  
          <div class="container1">
                  <div class="mame">
                      <div class="service-item wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
                          <div class="icon-box">
                              <img src="https://instabill.co/public/pro/6.png" alt="">
                          </div>
                          <div class="service-body">
                            <h3>Accounting Automation</h3>
                              <p>Sync Client Billing Software with Tally</p>
                              <p>No Human Accounting</p>
                              <p>Import Bank Statement</p>
                          </div>
                      
                      </div>
                  </div>
                   <div class="mame" style="background: linear-gradient(180deg, #f66a59 0%, #ffae00 100%)">
                      <div class="service-item wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
                          <div class="icon-box">
                              <img src="https://instabill.co/public/pro/7.png" alt="" style="    filter: brightness(0) invert(1);">
                          </div>
                          <div class="service-body">
                            <h3 style="color: #fff">GST Automation</h3>
                              <p style="color: #fff">Sync Sales from GSTR-1</p>
                              <p style="color: #fff">Sync Purchase from GSTR-2B</p>
                              <p style="color: #fff">Auto- Reconcile Sales & purchase</p>
                              <p style="color: #fff">File GST Returns in a click</p>
                              <p style="color: #fff">GST JSON</p>
                          </div>
                      
                      </div>
                  </div>
                   <div class="mame">
                      <div class="service-item wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
                          <div class="icon-box">
                             <img src="https://instabill.co/public/pro/8.png" alt="">
                          </div>
                          <div class="service-body">
                            <h3>Reports</h3>
                              <p>Client Tax Filing Management</p>
                              <p>Client Documents</p>
                              <p>Client Business Reports</p>
                          </div>
                      
                      </div>
                  </div>
              </div>
  
  
        
    
           <div class="clear"></div>
      </div>
  </div>
  
  
  
  <div class="five">
      <div class="four">
      <div class="in_four">
          <h1>Why Instabill Pro?</h1>
          <p>Instabill automates all the repetitive accounting tasks such as sale, purchase, banking, GST filing with its centralized ecosystem enabling the accounting practitioners and tax experts to focus more on value-added tasks.</p>
      </div>
  </div>
      <div class="in_five">
  
          <div class="a">
              <p>Before Instabill</p>
          </div>
          <div class="a">
              <p>After Instabill</p>
          </div>
          <div class="clear"></div>
  
          <div class="line">
              
              <div class="a1">
                  <p>Chasing Tax Paying Deadlines</p>
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd2838c81a805b3fc6f2a1_emoji-1.svg" loading="lazy" alt="Running Emoji" class="image-103">
              </div>
              <div class="a2">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62c84a4e403e69b26c82d922_image%20770.png" loading="lazy" alt="Right Arrow" class="image-115">
              </div>
              <div class="a1 pp">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd28f6a1d1aca697dbb835_emoji-7.svg" loading="lazy" alt="Emoji" class="image-103">
                  <p>Everything Ready automatically Before Deadlines</p>
              </div>
              
          </div>
          <!--  -->
          <div class="line">
             
              <div class="a1">
                   <p>Time Waste in Manual Data Entries</p>
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd2838c81a805b3fc6f2a1_emoji-1.svg" loading="lazy" alt="Running Emoji" class="image-103">
              </div>
              <div class="a2">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62c84a4e403e69b26c82d922_image%20770.png" loading="lazy" alt="Right Arrow" class="image-115">
              </div>
              <div class="a1 pp">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd28f6a1d1aca697dbb835_emoji-7.svg" loading="lazy" alt="Emoji" class="image-103">
                  <p>Automate Data Entries. Save Time</p>
              </div>
              
          </div>
          <!--  -->
          <div class="line">
             
              <div class="a1">
                   <p>Scattered Finance Documents</p>
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd2838c81a805b3fc6f2a1_emoji-1.svg" loading="lazy" alt="Running Emoji" class="image-103">
              </div>
              <div class="a2">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62c84a4e403e69b26c82d922_image%20770.png" loading="lazy" alt="Right Arrow" class="image-115">
              </div>
              <div class="a1 pp">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd28f6a1d1aca697dbb835_emoji-7.svg" loading="lazy" alt="Emoji" class="image-103">
                  <p>All Client Data at One Place</p>
              </div>
              
          </div>
          <!--  -->
          <div class="line">
             
              <div class="a1">
                   <p>Take lot of time to prepare financial report</p>
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd2838c81a805b3fc6f2a1_emoji-1.svg" loading="lazy" alt="Running Emoji" class="image-103">
              </div>
              <div class="a2">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62c84a4e403e69b26c82d922_image%20770.png" loading="lazy" alt="Right Arrow" class="image-115">
              </div>
              <div class="a1 pp">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd28f6a1d1aca697dbb835_emoji-7.svg" loading="lazy" alt="Emoji" class="image-103">
                  <p>Send impressive Monthly Business Report to clients in a click</p>
              </div>
              
          </div>
          <!--  -->
           <div class="line">
             
              <div class="a1">
                   <p>Asynchronous Data</p>
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd2838c81a805b3fc6f2a1_emoji-1.svg" loading="lazy" alt="Running Emoji" class="image-103">
              </div>
              <div class="a2">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62c84a4e403e69b26c82d922_image%20770.png" loading="lazy" alt="Right Arrow" class="image-115">
              </div>
              <div class="a1 pp">
                  <img src="https://assets-global.website-files.com/616e413168f920083d196689/62cd28f6a1d1aca697dbb835_emoji-7.svg" loading="lazy" alt="Emoji" class="image-103">
                  <p>Synchronized Data</p>
              </div>
              
          </div>
          <!--  -->
       
         
      </div>
       <p style="    text-align: center;"><a href="https://pro.instabill.co/signup" target="_blank">START NOW</a></p>
  </div>
  
  <div class="reports">
      <div class="in_re">
      <h1>Impress Clients with Clear, Easy-to-Read Business Performance Reports!</h1>
      <p>Reports for Your Clients, Beautifully Simplified.</p>
  </div>
      <div class="repotsa">
        <img src="https://instabill.co/public/pro/2.png" class="im1">
          <img src="https://instabill.co/public/pro/1.png" class="im2">
          <img src="https://instabill.co/public/pro/05.png" class="im3">
          <img src="https://instabill.co/public/pro/3.png" class="im4">
          <img src="https://instabill.co/public/pro/04.png" class="im5">
      </div>
  </div>
  <div class="unblock">
      <img src="https://instabill.co/public/pro/monay.png" class="money wow fadeInLeft" data-wow-delay="0.25s">
      <div class="in_unblock">
          <h1>Unlock Efficiency with Earnings<br>
  Instabill – Your Clients' Go-To Invoicing & <br>Inventory Solution!
  </h1>
  <p>Automate Clients Accounting, Elevate Your Income.</p>
      </div>
  
      <div class="unblock_l">
          <h2>Recommend <span>Instabill</span> to your clients, you earn <span>50% of the subscription fee</span> they pay.</h2>
      </div>
      <div class="unblock_r">
          <img src="https://instabill.co/public/pro/4.png">
      </div>
      <div class="clear"></div>
  </div>
  
  
  <div class="witha">
      <h2>With Instabill, <span style="color: #ffae00;
      background-color: #f71735;
      background-image: linear-gradient(147deg, #f8754b 0, #ffac03 74%);
      -webkit-background-clip: text;
      background-clip: text; 
      -webkit-text-fill-color: transparent;">Your Client   </span>
    <span> Can</span> </h2>
      <div class="me1">
          <img src="https://instabill.co/public/pro/5.png">
          <p>Available on <a href="https://pro.instabill.co/" target="_blank" class="btn gradient-bg" style="background: #000"><i class="fa fa-desktop" aria-hidden="true"></i> Web</a>
          <a href="https://play.google.com/store/apps/details?id=app.instabillpro" target="_blank" class="btn gradient-bg" style="    padding-left:7%;"><img src="https://instabill.co/public/pro/play-store.png"> Play Store</a> </p>
      </div>
      <div class="ma">
  
  
      <div class="boxa">
          <p><span>1.</span> Create Invoices </p>
      </div>
      <div class="boxa">
          <p><span style="background: linear-gradient(45deg,  rgba(255,101,165,1) 0%,rgba(255,101,165,1) 13%,rgba(255,107,154,1) 35%,rgba(255,134,106,1) 100%)">2.</span> Record Purchase & Expense </p>
      </div>
      <div class="boxa">
          <p><span style="background: -webkit-linear-gradient(45deg,  rgba(129,138,255,1) 0%,rgba(129,138,255,1) 7%,rgba(139,132,255,1) 17%,rgba(180,107,255,1) 42%,rgba(201,99,249,1) 56%,rgba(217,99,236,1) 68%,rgba(241,105,208,1) 83%,rgba(254,113,188,1) 95%,rgba(255,116,182,1) 100%)">3.</span> Manage Inventory </p>
      </div>
      <div class="boxa">
          <p><span style="background: linear-gradient(85deg, #f66a59, #ffae00)">4.</span> Do eInvoicing & eWayBill <br>and many more……</p>
      </div>
  
  
      
      </div>
  </div>
  
  
  
  
  <div class="six">
      <div class="in_six">
          <div class="six_l">
          <h1>Numbers Speak Louder than words</h1>
          <p>Numbers don’t lie, and neither do we!</p>
          </div>
          <div class="six_r">
              <div class="parent">
              <div class="first mt">
                  <div class="m">
                      <h3>100K <span class="text-span-5">+</span></h3>
                      <p>Instabill Users</p>
                  </div>
                  <div class="m">
                      <h3>1000 <span class="text-span-5">+</span></h3>
                      <p>Accounting Professionals trusted Instabill Pro</p>
                  </div>
              </div>
               <div class="first">
                  <div class="m">
                      <h3>1.5 Crore <span class="text-span-5">+</span></h3>
                      <p>Number of Entries processed automatically</p>
                  </div>
                  <div class="m">
                      <h3>2 Lakh <span class="text-span-5">+</span></h3>
                      <p>GST Return filed with <br>Instabill Pro</p>
                  </div>
              </div>
               </div>
          </div>
          <div class="clear"></div>
      </div>
  </div>
  
  
  
  
  <!-- packages -->
  <div class="pack" id="pricing">
      <div class="inner_pack">
          <h1>PRICING</h1>
          <div class="pack_1 ">
            
      
  
              <h2 style="margin-top: 30%;">Basic</h2>
              <div class="mrp">
                  <b><i class="fa fa-inr" aria-hidden="true"></i> 10,000</b>
                  <span>/ Year</span>
              </div>
  
              <div class="infoa">
                <p><i class="fa fa-phone" aria-hidden="true"></i> Unlimited Clients</p>  
                <p><i class="fa fa-user" aria-hidden="true"></i> Connect Client Profile </p>
                  <p><i class="fa fa-mobile" aria-hidden="true"></i> Integrate Tally Accounting</p>
                  <p><i class="fa fa-file-word-o" aria-hidden="true"></i> Document Management </p>
                  <p><i class="fa fa-user-plus" aria-hidden="true"></i> Client Management</p>
                  <p><i class="fa fa-file-text-o" aria-hidden="true"></i> Business Reports</p>
                  <p><i class="fa fa-ticket" aria-hidden="true"></i> 50% Referral</p>
                  <p><i class="fa fa-phone" aria-hidden="true"></i> Call Support</p>
                  
                  <button onclick="pay_now1()"><a href="https://instabill.co/pro_package" style="text-decoration: none;
      color: #fff;">Start my Trial</a></button>
              </div>
              
          </div>
  
          <div class="pack_1 center_p">
             
  
  
              <h2>Professional</h2>
              <div class="mrp">
                  <b><i class="fa fa-inr" aria-hidden="true"></i> 20,000</b>
                  <span>/ Year</span>
                  <p>Best Selling Plan   <img src="https://instabill.in/public/front/images/thumb.png" class="thumb_i" style=""></p>
              </div>
  
              <div class="infoa">
                <p><i class="fa fa-phone" aria-hidden="true"></i> Unlimited Clients</p>
                  <p><i class="fa fa-users" aria-hidden="true"></i> <b>Everything in Basic Plan</b></p>
                      <p><i class="fa fa-mobile" aria-hidden="true"></i> GST JSON</p>
                  <p><i class="fa fa-tags" aria-hidden="true"></i> GST Reconciliation </p>
                  <p><i class="fa fa-files-o" aria-hidden="true"></i> Auto Sync Tally with GST</p>
                 
                  <button onclick="pay_now2()"><a href="https://instabill.co/pro_package" style="text-decoration: none;
      color: #000;background: transparent;">Start my Trial</a></button>
              </div>
          
          </div>
  
          <div class="pack_1">
              <img src="https://instabill.in/public/front/images/ai_b.png" style="position: absolute;
      right: 0;    width: 100%;
      top: 0;    z-index: -1;">
              <h2>Automation </h2>
              <div class="mrp"><b><i class="fa fa-inr" aria-hidden="true"></i> 50,000</b><span>/ Year</span></div>
  
              <div class="infoa">
                <p><i class="fa fa-phone" aria-hidden="true"></i> Unlimited Clients</p>
                  <p><i class="fa fa-handshake-o" aria-hidden="true"></i> <b>Everything in Professional Plan</b></p>
  <p><i class="fa fa-refresh" aria-hidden="true"></i> Ai based Accounting Automation</p>
  
  
                  <button onclick="pay_now3()"><a href="https://instabill.co/pro_package" style="text-decoration: none;
      color: #fff;">Start my Trial</a></button>
              </div>
          
          </div>
      </div>
  </div>
  <div class="seven">
      <div class="in_Seven">
          <div class="secure">
              <img src="https://assets-global.website-files.com/616e413168f920083d196689/654ca9450372c8364bc73a16_servers%201.png" loading="lazy" alt="server" class="image-160">
          </div>
          <div class="secure_r">
              <h1>Your Data is 100% Secure</h1>
              <p>We encrypt your accounting data and store it on world-class cloud infrastructure for top-tier security. Our desktop and mobile apps communicate securely with this data. Plus, we use strong 256-bit encryption to keep your information safe.</p>
          </div>
      </div>
  </div>
  <section class="accordion accordion--radio">
      <h3>Frequently Asked Questions</h3>
    <div class="tab">
      <input type="radio" name="accordion-1" id="rd1">
      <label for="rd1" class="tab__label">Can I get a free trial of Instabill Pro?</label>
      <div class="tab__content">
        <p>You can avail a free one-day software demo. The trial pack includes seven working days for a smooth and seamless experience for the Instabill Pro family.<br>
  
  Note: You will have access to add only a single company in the trial period.</p>
      </div>
    </div>
    <div class="tab">
      <input type="radio" name="accordion-2" id="rd2">
      <label for="rd2" class="tab__label">What kind of assistance does Instabill Pro offer?</label>
      <div class="tab__content">
        <p>A ticket can be generated and raised in the admin panel. Our technical support will be available right away and respond in the chatbox.</p>
      </div>
    </div>
    <div class="tab">
      <input type="radio" name="accordion-3" id="rd3">
      <label for="rd3" class="tab__label">Can I get a free trial of Instabill Pro?</label>
      <div class="tab__content">
        <p>You can avail a free one-day software demo. The trial pack includes seven working days for a smooth and seamless experience for the Instabill Pro family.<br>
  
  Note: You will have access to add only a single company in the trial period.</p>
      </div>
    </div>
    <div class="tab">
      <input type="radio" name="accordion-4" id="rd4">
      <label for="rd4" class="tab__label">What kind of assistance does Instabill Pro offer?</label>
      <div class="tab__content">
        <p>A ticket can be generated and raised in the admin panel. Our technical support will be available right away and respond in the chatbox.</p>
      </div>
    </div>
    <div class="tab">
      <input type="radio" name="accordion-5" id="rd5">
      <label for="rd5" class="tab__label">Can I get a free trial of Instabill Pro?</label>
      <div class="tab__content">
        <p>You can avail a free one-day software demo. The trial pack includes seven working days for a smooth and seamless experience for the Instabill Pro family.<br>
  
  Note: You will have access to add only a single company in the trial period.</p>
      </div>
    </div>
    <div class="tab">
      <input type="radio" name="accordion-6" id="rd6">
      <label for="rd6" class="tab__label">What kind of assistance does Instabill Pro offer?</label>
      <div class="tab__content">
        <p>A ticket can be generated and raised in the admin panel. Our technical support will be available right away and respond in the chatbox.</p>
      </div>
    </div>
   
  </section>
  
  
  <section class="s_efficiency"><div class="s_container"><div class="s_efficiency-bg"><div class="s_row s_align-center"><div class="s_col-7"><div class="s_efficiency-content"><h4>Reduce Your Manual Accounting, Boost Your Efficiency & Earning.</h4><p>Let Instabill Pro handle the mundane tasks, so you can focus on the major work!</p>
     
      <div class="s_flex s_align-center s_home-hero-left-btn">
        <router-link class="s_button s_button-trans s_ml-10"  target="_blank" to="/bookdemo">Book a Demo </router-link>  
         <a class="s_button s_button-trans s_ml-10" target="_blank" href="https://pro.instabill.co/signup">Free Trial<!-- --> </a></div></div></div><div class="s_col-5"><div class="s_efficiency-img"><div class="s_efficiency-img-round1"><div class="s_efficiency-img-round1-myntra"><img alt="s_myntra" loading="lazy" width="16" height="16" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_myntra.svg"></div><div class="s_efficiency-img-round1-flipkart"><img alt="s_flipkart" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_flipkart.svg"></div><div class="s_efficiency-img-round1-amazon"><img alt="s_amazon" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_amazon.svg"></div><div class="s_efficiency-img-round1-meesho"><img alt="s_meesho" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent" sizes="100vw" src="https://instabill.co/public/images/Meesho_logo.png" srcset=""></div></div><div class="s_efficiency-img-round2"><div class="s_efficiency-img-round2-bob"><img alt="s_bob" loading="lazy" width="18" height="18" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_bob.svg"></div><div class="s_efficiency-img-round2-hdfc"><img alt="s_hdfc" loading="lazy" width="18" height="18" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_hdfc.svg"></div><div class="s_efficiency-img-round2-sbi"><img alt="s_sbi" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_sbi.svg"></div><div class="s_efficiency-img-round2-kotak"><img alt="s_kotak" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_kotak.svg"></div></div><div class="s_efficiency-img-round3"><div class="s_efficiency-img-round3-image"><img alt="s_image" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_image.svg"></div><div class="s_efficiency-img-round3-pdf"><img alt="s_pdf" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_pdf.svg"></div><div class="s_efficiency-img-round3-api"><img alt="s_api" loading="lazy" width="16" height="16" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_api.svg"></div><div class="s_efficiency-img-round3-excel"><img alt="s_excel" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" style="color:transparent" src="https://static.suvit.io/images/efficiency/icon/s_excel.svg"></div></div><div class="s_efficiency-img-logo"><div class="s_efficiency-img-logo-bg"><img alt="s_suvit-icon" loading="lazy" width="40" height="38" decoding="async" data-nimg="1" style="color:transparent" src="https://instabill.co/public/front/images/favicon.png"></div></div></div></div></div></div></div></section>
  
  
  
  <div class="footer">
      <p style="margin:0px">© Copyright All Right Reserved</p>
  </div>

  </body>
  </html>
</template>
<script>
import $ from 'jquery';
export default {
    
  name: "Home",
beforeCreate(){
var checker=localStorage.getItem('admin_id');
  if(checker ==null)
  {
    console.log("signin page");
  }
  else
  {
    this.$router.push("/Dashboard");
  }
},
methods:{
     showNavbar(){
        $('.navbar-right').toggle();
    }
}
 
};

</script>

<style>
    /* Define the shape and color of the hamburger lines */
.navbar-toggle span {
        display: block;
    background-color: #fff;
    height: 2px;
    width: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
    position: relative;
    opacity: 1;
    transition: all 0.35s ease-out;
    transform-origin: center left;
    left: 2px;
    width: 20px;
    height: 2px;
    display: block;
    margin-top: 3px;
    background: #fff;
}


/* top line needs a little padding */
.navbar-toggle span:nth-child(1) {
    margin-top: 0.3em;
}

/**
 * Animate collapse into X.
 */

/* top line rotates 45 degrees clockwise and moves up and in a bit to close the center of the X in the center of the button */
.navbar-toggle:not(.collapsed) span:nth-child(1) {
    transform: translate(15%, -33%) rotate(45deg);
}
/* center line goes transparent */
.navbar-toggle:not(.collapsed) span:nth-child(2) {
    opacity: 0;
}
/* bottom line rotates 45 degrees counter clockwise, in, and down a bit to close the center of the X in the center of the button  */
.navbar-toggle:not(.collapsed) span:nth-child(3) {
    transform: translate(15%, 33%) rotate(-45deg) ;
}


/**
 * Animate collapse open into hamburger menu
 */

/* top line moves back to initial position and rotates back to 0 degrees */
.navbar-toggle span:nth-child(1) {
    transform: translate(0%, 0%) rotate(0deg) ;
}
/* middle line goes back to regular color and opacity */
.navbar-toggle span:nth-child(2) {
    opacity: 1;
}
/* bottom line goes back to initial position and rotates back to 0 degrees */
.navbar-toggle span:nth-child(3) {
    transform: translate(0%, 0%) rotate(0deg) ;
}


.in_right img {
    width: 60%;
}
.s_efficiency-img {
    position: relative;
    width: 350px;
    height: 350px;
    margin-left: auto;
}
.footer {
    text-align: center;
    padding: 2%;
    background: #333;
    color: #fff;
    margin-top: 5%;
}
/* Core styles/functionality */
.tab input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.tab__content {
  max-height: 0;
  overflow: hidden;
  transition: all 0.35s;
}
.tab input:checked ~ .tab__content {
  max-height: 10rem;
}

/* Visual styles */

.tab__label,
.tab__close {
    display: flex;
    color: black;
    cursor: pointer;
}
.tab__label {
  justify-content: space-between;
  padding: 1rem;
}
.tab__label::after {
  content: "\276F";
  width: 1em;
  height: 1em;
  text-align: center;
  transform: rotate(90deg);
  transition: all 0.35s;
}
.tab input:checked + .tab__label::after {
  transform: rotate(270deg);
}
.tab__content p {
  margin: 0;
  padding: 1rem;
}
.tab__close {
  justify-content: flex-end;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
}
.accordion--radio {
  --theme: var(--secondary);
}

/* Arrow animation */
.tab input:not(:checked) + .tab__label:hover::after {
  animation: bounce .5s infinite;
}
@keyframes bounce {
  25% {
    transform: rotate(90deg) translate(.25rem);
  }
  75% {
    transform: rotate(90deg) translate(-.25rem);
  }
}
.menu-area.navbar-fixed-top {
    background: linear-gradient(85deg, #f66a59, #ffae00);
    padding-bottom: 1%;
}
*{margin: 0px;padding: 0px;   font-family: system-ui;}
.ban{     background: linear-gradient(85deg, #f66a59, #ffae00);
    overflow: hidden;
    padding: 7% 0%;
    padding-top: 10%;}
.in_two {
    width: 80%;
    margin: auto;
    font-size: 31px;
    text-align: center;
    border: 2px dotted #fea113;
    border-radius: 27px;
    padding: 2%;
    margin-top: 7%;
    margin-bottom: 7%;
}
.in_two h1 span{color: #fea113;}
.in_ban {
    width: 90%;
    margin: auto;
}
.in_right h3 {
        font-size: 38px;
    color: #091846;
    margin-bottom: 10px;
    font-weight: 900;
}

.in_right {    width: 57%;
    margin: auto;
    height: 232px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.in_right p {
    font-size: 24px;
    line-height: 26px;
    margin-top: 4%;
}
.ina span {
        box-shadow: 0px 20px 50px 0px rgba(153, 153, 153, 0.1);
    background: #eee;
    padding: 8px 2% 11px;
    border-radius: 43px;
    cursor: pointer;
    animation-name: example;
}
a.navbar-brand img {
    width: 193px;
}
span.p1 {
    animation-duration: 10s;
}
@keyframes example {
  0%   {left:50%; top:2%;}
  30%   {left:79%; top:2%;}
  40%   {left:79%; top:41%;}
  50%   {left:79%; top:84%;}
  60%   {left:46%; top:84%;}
  70%   {left:23%; top:84%;}
  80%   {left:13%; top:65%;}
  90%   {left:13%; top:37%;}
  100%   {left:12%; top:15%;}
}
span.p2 {
    animation-name: examplea;
    animation-duration: 20s;
}
@keyframes examplea {
  0%   {left:23%; top:2%;}
  30%   {left:80%; top:2%;}
  40%   {left:86%; top:38%;}
  50%   {left:82%; top:67%;}
  60%   {left:67%; top:84%;}
  70%   {left:24%; top:84%;}
  80%   {left:12%; top:66%;}
  90%   {left:7%; top:39%;}
  100%   {left:5%; top:39%;}
}
span.p3 {
    animation-name: exampleb;
    animation-duration: 20s;
}
@keyframes exampleb {
  0%   {left:9%; top:2%;}
  30%   {left:44%; top:2%;}
  40%   {left:74%; top:16%;}
  50%   {left:79%; top:68%;}
  60%   {left:67%; top:84%;}
  70%   {left:24%; top:84%;}
  80%   {left:12%; top:66%;}
  90%   {left:7%; top:39%;}
  100%   {left:5%; top:39%;}
}
.in_right a {
    background: linear-gradient(85deg, #f66a59, #ffae00);
    color: #fff;
    padding: 1% 3%;
    margin-top: 5%;
    font-size: 17px;
    display: inline-block;
    margin-bottom: 5%;
    border-radius: 5px;
}
.ina span:hover {
    background: #eee;
    color: #000;
}
.eight {
       width: 85%;
    margin: 6% auto;
    text-align: center;
    padding: 5%;
    position: relative;
}
.left_a {    width: 50%;
    float: left;
    color: #fff;
     font-family: system-ui;
    font-size: 22px;
}
a.tally {
    border: 1px solid #fff;
    padding: 7px 5%;
    color: #fff;
    font-family: system-ui;
    text-decoration: none;
    border-radius: 50px;
    margin-bottom: 4%;
    display: inline-block;
}
.left_a h1 {    line-height: 70px;
    font-family: system-ui;
    font-size: 59px;
    color: #fff;
    font-weight: 800;
}
a.start {
    background: linear-gradient(45deg, rgba(129,138,255,1) 0%,rgba(129,138,255,1) 7%,rgba(139,132,255,1) 17%,rgba(180,107,255,1) 42%,rgba(201,99,249,1) 56%,rgba(217,99,236,1) 68%,rgba(241,105,208,1) 83%,rgba(254,113,188,1) 95%,rgba(255,116,182,1) 100%);
    text-decoration: none;
    color: #fff;
    padding: 2% 4%;
    border-radius: 10px;
    display: inline-block;
    margin-top: 5%;
}
.left_a span {
    font-size: 15px;
}
.bo img {
    margin-top: 2%;
}
.left_b {
    width: 50%;
    float: left;
    text-align: right;
}
.in_three h1 {
    text-align: center;
    font-size: 44px;
}

.sec_1 {
    width: 31%;
    float: left;
    background: #ff65a51a;
    border: 1px solid #ffd6bf;
    margin: 1%;
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    box-shadow: 0px 20px 50px 0px rgba(153, 153, 153, 0.1);
}

.sec_1 img {    width: 90%;
    display: block;
    text-align: center;
    margin: auto;
}

.sec_1 ul li {list-style: none;
    color: #000;
}
.sec_1 ul {
    margin-bottom: 10%;
}
.sec_1 .link_learn {
    background: linear-gradient(45deg,  rgba(255,101,165,1) 0%,rgba(255,101,165,1) 13%,rgba(255,107,154,1) 35%,rgba(255,134,106,1) 100%);
    color: #fff;
    text-decoration: none;
    padding: 3% 7%;
    border-radius: 5px;
    box-shadow: 0px 10px 15px 0px rgba(255, 101, 165, 0.3);
}
.clear{clear: both;}
.sec_1 ul{padding: 0px;}
.sec_1 ul li a {
    color: #000;
    text-decoration: none;
    font-size: 17px;
}
.sec_1 h3 {
    font-size: 22px;
    color: #000;
    margin-bottom: 2%;
    margin-top: 5%;
}
.sec_1 ul li i {
    color: #ff65a5;
    margin-right: 2%;
}
.in_four h1 {
    text-align: center;
    font-size: 44px;
    margin-bottom: 2%;
}

.in_four {
        text-align: center;
    width: 70%;
    margin: auto;
    font-size: 20px;
    padding: 6% 0%;
}
.in_five {
      background: #ffffff;
    width: 85%;
    margin: auto;
    box-sizing: border-box;
    box-shadow: 0 20px 50px 0 rgb(153 153 153 / 10%);
    border-radius: 10px;
    margin-bottom: 5%;
    border: 1px solid #eee;
}
.five a {
    background: linear-gradient(85deg, #f66a59, #ffae00);
    color: #fff;
    text-decoration: none;
    font-size: 17px;
    padding: 1%;
    border-radius: 5px;
    display: inline-block;
    margin: auto;
    margin-bottom: 1%;
}
.a {
    width: 50%;
    float: left;
    text-align: center;
}
.a p {
    background: linear-gradient(45deg,  rgba(129,138,255,1) 0%,rgba(129,138,255,1) 7%,rgba(139,132,255,1) 17%,rgba(180,107,255,1) 42%,rgba(201,99,249,1) 56%,rgba(217,99,236,1) 68%,rgba(241,105,208,1) 83%,rgba(254,113,188,1) 95%,rgba(255,116,182,1) 100%);
    width: 33%;
    margin: auto;
    color: #fff;
    padding: 2%;
    font-size: 21px;
    border-radius: 0px 0px 10px 10px;
}
.five {
    margin-top: 5%;
}
.line {
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 20px;
    padding: 2% 1%;
}
img.image-103 {
          background: linear-gradient(45deg, rgb(255 101 165 / 28%) 0%,rgb(255 101 165 / 39%) 13%,rgb(255 107 154 / 28%) 35%,rgb(255 134 106 / 26%) 100%);
    width: 50px;
    height: 50px;
    padding: 2%;
    border-radius: 50px;
    margin: 0px 20px;
}
.pp{justify-content: flex-start!important;}
.a1 {
    width: 45%;
    justify-content: flex-end;
    align-items: center;
    display: flex;
}
.a2 {
    width: 160px;
    text-align: center;
}
.five {
    margin-top: 5%;
    padding-bottom: 7%;
}
.six_l {    width: 50%;
    float: left;
    padding-left: 9%;
    box-sizing: border-box;
    margin-top: 8%;
}

.in_six {
    margin: auto;
    padding: 7% 0%;
    padding-top: 0px;   
}
.secure_r h1 {
    font-size: 51px;
    margin-bottom: 2%;
    font-weight: 800;
}
.six_l h1 {
    font-size: 51px;
    margin-bottom: 2%;
    font-weight: 800;
}

.six_l p {
    font-size: 20px;
}

.six_r {
       width: 50%;
    float: right;
    background: linear-gradient(85deg, #f66a59, #ffae00);
    padding: 3%;
    box-sizing: border-box;
    position: relative;
    border-radius: 10px 0px 0px 10px;
}

.first {
    width: 50%;
    flex-wrap: wrap;
    margin-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
}
.six_r span {
    text-align: right;
    display: block;
    color: #fff;
    margin-bottom: 12%;
}   
.parent {
    flex-direction: row;
    display: flex;
}
.mt{    margin-top: -7px;}
.m {
       background: #fff;
    box-shadow: 0px 20px 50px 0px rgba(153, 153, 153, 0.1);
    padding: 5%;
    width: 100%;
    border-radius: 7px;
    text-align: center;
    margin-bottom: 34px;
    height: 145px;
    padding-top: 16%;
    box-sizing: border-box;
}
.m span {
    color: #000;
    display: inline-block;
    margin-bottom: 0px;
}
.m h3 {
    font-size: 25px;
}
.in_Seven {
       width: 72%;
    margin: auto;
    text-align: center;
    padding-bottom: 5%;
}
.in_Seven img {
    width: 100px;
}
.seven {
       overflow: hidden;
    background:#e9ebf9;
    padding: 6% 0% 2%;
    color: #000;
}
.secure_r p {
    font-size: 20px;
}

.secure_r {
    font-size: 26px;
}

section.accordion.accordion--radio {
    width: 63%;
    margin: auto;
    margin-top: 2%;
}
.tab {
    border: 1px solid #ced2dc;
    margin-bottom: 2%;
    border-radius: 5px;
}
section.accordion.accordion--radio h3 {
       font-size: 51px;
    text-align: center;
    margin-bottom: 6%;
    font-weight: 800;
}
.menu-area {
    height: 90px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
}.navbar-fixed-bottom, .navbar-fixed-top {
    position: fixed;
    right: 0;
    left: 0;    top: 0px;
    z-index: 1030;
}.mainmenu {
    margin-top: 12px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
}.navbar-brand {
    padding: 0;
    font-size: 36px;
    display: flex;
    color: #b050ff;
    align-items: center;
    text-transform: uppercase;
}
button.navbar-toggle {
    display: none;
}
.navbar-collapse {height:auto!important;
    flex-basis: initial!important;
    flex-grow: inherit!important;}
.navbar-brand {
    float: left;
    height: 50px;
    padding: 15px 15px;
    font-size: 18px;
    line-height: 20px;
}.navbar-nav li {
    float: none;
    display: inline-block;
}.navbar-nav li a {
    color: #fff!important;
    font-size: 14px;border: 2px solid transparent;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
}
.navbar.navbar-nobg {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.menu-area {
    height: 90px;}
.mainmenu {
    padding: 0% 2%;
}
.navbar-nav a.btn {
    color: #fff;
    padding: 10px 25px;
    margin-left: 20px;
}.navbar-nav li a {
    color: #fff;
    font-size: 15px;
    text-decoration: none;
    padding: 1px 12px;
    font-weight: 600;
}.red-bg {
    box-shadow: 0px 10px 15px 0px rgba(255, 101, 165, 0.3);
    background: rgb(255, 101, 165);
    background: -moz-linear-gradient(45deg, rgba(255, 101, 165, 1) 0%, rgba(255, 101, 165, 1) 13%, rgba(255, 107, 154, 1) 35%, rgba(255, 134, 106, 1) 100%);
    background: -webkit-linear-gradient(45deg, rgba(255, 101, 165, 1) 0%, rgba(255, 101, 165, 1) 13%, rgba(255, 107, 154, 1) 35%, rgba(255, 134, 106, 1) 100%);
    background: linear-gradient(45deg, rgba(255, 101, 165, 1) 0%, rgba(255, 101, 165, 1) 13%, rgba(255, 107, 154, 1) 35%, rgba(255, 134, 106, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff65a5', endColorstr='#ff866a',GradientType=1 );
}a.red-bg {
      border-radius: 5px;
    padding: 11px 21px !important;
    margin-right: 5px;
}
p.mm {
    text-align: center;
    margin-bottom: 3%;
    font-size: 20px;
}
.start:after {
    content: '';
    position: absolute;
    display: none;
    width: 200px;
    height: 100px;
    -webkit-transform: translate3d(-109%, -50px, 0) rotate3d(0, 0, 1, 45deg);
    -ms-transform: translate3d(-109%, -50px, 0) rotate3d(0, 0, 1, 45deg);
    transform: translate3d(63%, -58px, 0) rotate3d(0, 0, 1, 45deg);
    transition: all 1.1s cubic-bezier(.19,1,.22,1);
    background: rgba(255, 255, 255, .5);
    left: 0;
    top: 0;
    animation: effts1 1s infinite;
}
.start{position: relative;overflow: hidden;    display: inline-flex;}
.start:hover:after {
    display: block;
}
.sho a:after {
    content: '';
    position: absolute;
    display: none;
    width: 200px;
    height: 100px;
    -webkit-transform: translate3d(-109%, -50px, 0) rotate3d(0, 0, 1, 45deg);
    -ms-transform: translate3d(-109%, -50px, 0) rotate3d(0, 0, 1, 45deg);
    transform: translate3d(63%, -58px, 0) rotate3d(0, 0, 1, 45deg);
    transition: all 1.1s cubic-bezier(.19,1,.22,1);
    background: rgba(255, 255, 255, .5);
    left: 0;
    top: 0;
    animation: effts1 1s infinite;
}
.sho a{position: relative;overflow: hidden;    display: inline-flex;}
.sho a:hover:after {
    display: block;
}
@keyframes  effts1{
    0%{
        transform: translate3d(-109%,-50px,0) rotate3d(0,0,1,45deg);
    }
    50%{
        transform: translate3d(40%,-50px,0) rotate3d(0,0,1,45deg);
    }
    100%{
        transform: translate3d(80%,-50px,0) rotate3d(0,0,1,45deg);
    }
}
.bornder a{    background: transparent;
    border: 2px solid #fff!important;}
.bornder a{background: transparent;}
span.p1 {    position: absolute;
    left: 12%;
    top: 15%;}
span.p2 {
      position: absolute;
    left: 5%;
    top: 39%;
    background: linear-gradient(45deg, rgb(246, 107, 89) 0%, rgb(247, 113, 80) 19%, rgb(251, 143, 41) 72%, rgb(253, 159, 19) 100%);
    color: #fff;
}
span.p3 {
       position: absolute;
    left: 9%;
    top: 66%;
    background: linear-gradient(45deg, rgba(255, 101, 165, 1) 0%, rgba(255, 101, 165, 1) 13%, rgba(255, 107, 154, 1) 35%, rgba(255, 134, 106, 1) 100%);
    color: #fff;
}
span.p1 {
    background: linear-gradient(45deg, rgba(102, 204, 153, 1) 0%, rgba(108, 205, 148, 1) 19%, rgba(136, 209, 125, 1) 72%, rgba(146, 211, 117, 1) 100%);
    color: #fff;
}
span.p4 {
        position: absolute;
    left: 22%;
    bottom: 4%;
    background: linear-gradient(45deg, rgba(129, 138, 255, 1) 0%, rgba(129, 138, 255, 1) 7%, rgba(139, 132, 255, 1) 17%, rgba(180, 107, 255, 1) 42%, rgba(201, 99, 249, 1) 56%, rgba(217, 99, 236, 1) 68%, rgba(241, 105, 208, 1) 83%, rgba(254, 113, 188, 1) 95%, rgba(255, 116, 182, 1) 100%);
    color: #fff;
}
span.p5 {
        position: absolute;
    right: 12%;
    top: 16%;
    background: linear-gradient(45deg, rgba(255, 101, 165, 1) 0%, rgba(255, 101, 165, 1) 13%, rgba(255, 107, 154, 1) 35%, rgba(255, 134, 106, 1) 100%);
    color: #fff;
}
span.p6 {
         position: absolute;
    right: 3%;
    top: 39%;
    background: linear-gradient(45deg, rgba(129, 138, 255, 1) 0%, rgba(129, 138, 255, 1) 7%, rgba(139, 132, 255, 1) 17%, rgba(180, 107, 255, 1) 42%, rgba(201, 99, 249, 1) 56%, rgba(217, 99, 236, 1) 68%, rgba(241, 105, 208, 1) 83%, rgba(254, 113, 188, 1) 95%, rgba(255, 116, 182, 1) 100%);
    color: #fff;
}
span.p7 {
         position: absolute;
    right: 9%;
    top: 66%;
    background: linear-gradient(45deg, rgba(102, 204, 153, 1) 0%, rgba(108, 205, 148, 1) 19%, rgba(136, 209, 125, 1) 72%, rgba(146, 211, 117, 1) 100%);
    color: #fff;
}
span.p8 {
          position: absolute;
    right: 24%;
    bottom: 5%;
    background: linear-gradient(45deg, rgb(246, 107, 89) 0%, rgb(247, 113, 80) 19%, rgb(251, 143, 41) 72%, rgb(253, 159, 19) 100%);
    color: #fff;
}
.in_re {
    text-align: center;
    width: 70%;
    margin: auto;
    font-size: 20px;
    padding: 6% 0%;
}

.in_re h1 {
    text-align: center;
    font-size: 44px;
    margin-bottom: 2%;
}   .in_re {
    text-align: center;
    width: 70%;
    margin: auto;
    font-size: 20px;
    padding: 6% 0%;
}

.in_re h1 {
    text-align: center;
    font-size: 44px;
    margin-bottom: 2%;
}

.repotsa {
    position: relative;
    width: 70%;
    margin: auto;
    height: 700px;
}

.repotsa img {
    position: absolute;
}

img.im2 {
    width: 39%;
    left: -8%;
    border: 1px solid #e9ebf9;
    bottom: 24%;
    padding: 1%;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 20px 50px rgba(0, 0, 0, .1);
}

img.im3 {
    width: 40%;
    border: 1px solid #e9ebf9;
    right: -4%;
    top: 27%;
    padding: 1%;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 20px 50px rgba(0, 0, 0, .1);
}
img.im4 {
    width: 33%;
    border: 1px solid #e9ebf9;
    left: -6%;
    top: -6%;
    padding: 1%;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 20px 50px rgba(0, 0, 0, .1);
}

img.im5 {
    width: 32%;
    border: 1px solid #e9ebf9;
    right: -11%;
    padding: 1%;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 20px 50px rgba(0, 0, 0, .1);
    top: -3%;
}
img.im1 {
    width: 57%;
    border: 1px solid #e9ebf9;
    left: 25%;
    top: -8%;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 20px 50px 0 rgb(153 153 153 / 10%);
    padding: 1%;
}
.in_unblock {
    text-align: center;
    margin: auto;
    font-size: 20px;
    padding: 6% 0%;
}
.in_unblock {
    text-align: center;
    margin: auto;
    font-size: 20px;
    padding: 6% 0%;
}

.in_unblock h1 {
    text-align: center;
    font-size: 44px;
    margin-bottom: 2%;
    line-height: 55px;
}

.unblock {
     width: 80%;
    margin: auto;
    /* overflow: hidden; */
    position: relative;
}

.unblock_l {
    width: 50%;
    float: left;
}

.unblock_r {
    width: 50%;
    float: right;
}

.unblock_r img {
    width: 85%;
    float: right;
}

.unblock_l h2 {
       font-size: 45px;
    margin-bottom: 2%;
    margin-top: 21%;
    width: 100%;
    font-weight: 800;
}
.in_unblock h1 {
    text-align: center;
    font-size: 44px;
    margin-bottom: 2%;
    line-height: 55px;
}
.reports {
    background: #e9ebf9;
}
.witha {
    margin: 6% auto;
    overflow: hidden;
    padding: 7% 9%;
    margin-bottom: 0px;}
.ma h2 {
      line-height: 55px;
    font-size: 45px;
    margin-bottom: 2%;
    margin-top: 0%;
    width: 100%;
    font-weight: 800;
    padding-left: 20%;
}
.witha h2 {
    text-align: center;
    font-size: 44px;
    margin-bottom: 7%;
    line-height: 55px;
}
.boxa p span {
    width: 48px;
    height: 48px;
    display: inline-block;
    background: linear-gradient(45deg,  rgba(102,204,153,1) 0%,rgba(108,205,148,1) 19%,rgba(136,209,125,1) 72%,rgba(146,211,117,1) 100%);
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 5px;
    font-size: 25px;
    margin-right: 8px;
}
.ma {     width: 50%;
    float: right;
    padding-left: 12%;
    box-sizing: border-box;
}

section.s_efficiency {
    padding: 40px 40px;
}
button.s_button {
    background: transparent;
    border: 2px solid #fff;
    color: #fff;
    font-size: 16px;
    padding: 10px 17px 13px;
    border-radius: 5px;
    font-weight: 500;
    margin-right: 13px;
}

a.s_button.s_button-trans.s_ml-10 {
    background: transparent;
    border: 2px solid #fff;
    color: #fff;
    font-size: 16px;
    padding: 10px 17px 13px;
    border-radius: 5px;
    font-weight: 500;
    margin-right: 13px;
    text-decoration: none;
}
.s_efficiency-bg {
    overflow: hidden;
    border-radius: 10px;
    background:linear-gradient(85deg, #f66a59, #ffae00);
    padding: 40px 47px;
    position: relative;
    z-index: 1;
}

.s_row.s_align-center {
    display: flex;
    flex-wrap: wrap;
    margin-right: -10px;
    margin-left: -10px;
}

.s_efficiency-content {
       display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    margin-top: 54px;
}

.s_efficiency-content h4 {
       font-size: 32px;
    color: #fff;
    margin-bottom: 12px;
}

.s_col-7 {
    width: 60%;
}

.s_col-5 {
    width: 40%;
}

.s_efficiency-content p {
    font-size: 20px;
    color: #fff;
    margin-bottom: 44px;
    margin-top: 9px;
}



.s_efficiency-img-round1 {
    width: 100%;
    height: 100%;
    border: 1px solid #fb9127;
    background-color: #fb9124;
    box-shadow: 0 0 20px 0 rgb(183 98 6 / 44%);
    border-radius: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    position: relative;
    animation: s_Rotate-1 20s linear infinite;
    -webkit-animation: s_Rotate-1 20s linear infinite;
}

.s_efficiency-img-round2 {
    animation: s_circle-rotate-2 20s linear infinite;
    -webkit-animation: s_circle-rotate-2 20s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    -webkit-transform: translate(-50%, -50%) rotate(45deg);
    width: 75%;
    height: 75%;
     border: 1px solid #fb9127;
    background-color: #fb9124;
    box-shadow: 0 0 20px 0 rgb(183 98 6 / 44%);
    border-radius: 100%;
}

.s_efficiency-img-round3 {
    animation: s_circle-rotate-3 20s linear infinite;
    -webkit-animation: s_circle-rotate-3 20s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    -webkit-transform: translate(-50%, -50%) rotate(45deg);
    width: 50%;
    height: 50%;
     border: 1px solid #fb9127;
    background-color: #fb9124;
    box-shadow: 0 0 20px 0 rgb(183 98 6 / 44%);
    border-radius: 100%;
}

.s_efficiency-img-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.s_efficiency-img-round1-myntra {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.s_efficiency-img-round1-amazon, .s_efficiency-img-round1-flipkart, .s_efficiency-img-round1-meesho, .s_efficiency-img-round1-myntra {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 50%;
    width: 36px;
    height: 36px;
}

.s_efficiency-img-round1-flipkart {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    -webkit-transform: translate(50%, -50%);
}

.s_efficiency-img-round1-amazon {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.s_efficiency-img-round1-meesho {
    right: 0;
    bottom: -15px;
    left: 0;
    margin: 0 auto;
}

.s_efficiency-img-round1-amazon, .s_efficiency-img-round1-flipkart, .s_efficiency-img-round1-meesho, .s_efficiency-img-round1-myntra {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 50%;
    width: 36px;
    height: 36px;
}

.s_efficiency-img-round1-amazon img, .s_efficiency-img-round1-flipkart img, .s_efficiency-img-round1-meesho img, .s_efficiency-img-round1-myntra img {
    animation: s_Rotate-reverse-1 20s linear infinite;
    -webkit-animation: s_Rotate-reverse-1 20s linear infinite;
    max-width: 100%;
}

.s_efficiency-img-round2-bob {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.s_efficiency-img-round2-hdfc {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    -webkit-transform: translate(50%, -50%);
}

.s_efficiency-img-round2-bob, .s_efficiency-img-round2-hdfc, .s_efficiency-img-round2-kotak, .s_efficiency-img-round2-sbi {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 100%;
    width: 36px;
    height: 36px;
}

.s_efficiency-img-round2-bob img, .s_efficiency-img-round2-hdfc img, .s_efficiency-img-round2-kotak img, .s_efficiency-img-round2-sbi img {
    animation: s_img-rotate-2 20s linear infinite;
    -webkit-animation: s_img-rotate-2 20s linear infinite;
    max-width: 100%;
}

.s_efficiency-img-round2-sbi {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.s_efficiency-img-round2-kotak {
    right: 0;
    bottom: -15px;
    left: 0;
    margin: 0 auto;
}

.s_efficiency-img-round3-image {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.s_efficiency-img-round3-api, .s_efficiency-img-round3-excel, .s_efficiency-img-round3-image, .s_efficiency-img-round3-pdf {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 100%;
    width: 36px;
    height: 36px;
}

.s_efficiency-img-round3-api img, .s_efficiency-img-round3-excel img, .s_efficiency-img-round3-image img, .s_efficiency-img-round3-pdf img {
    animation: s_img-rotate-3 20s linear infinite;
    -webkit-animation: s_img-rotate-3 20s linear infinite;
    max-width: 100%;
}

.s_efficiency-img-round3-pdf {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    -webkit-transform: translate(50%, -50%);
}

.s_efficiency-img-round3-api {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.s_efficiency-img-round3-excel {
    right: 0;
    bottom: -15px;
    left: 0;
    margin: 0 auto;
}

.s_efficiency-img-logo-bg {
    border-radius: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  border: 1px solid #fb9127;
    box-shadow: 0 0 20px 0 rgb(183 98 6 / 44%);
    width: 60px;
    height: 60px;
}
@keyframes s_Rotate-1{
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(1turn);
}
}
@keyframes s_circle-rotate-2{
0% {
    transform: translate(-50%, -50%) rotate(45deg);
}
100% {
    transform: translate(-50%, -50%) rotate(405deg);
}
}
@keyframes s_circle-rotate-3{
0% {
    transform: translate(-50%, -50%) rotate(90deg);
}
100% {
    transform: translate(-50%, -50%) rotate(450deg);
}
}
img.money {
    position: absolute;
    left: -8%;
    width: 24%;
    top: 9%;
    opacity: 0.2 !important;
}
.ma ul li {
    list-style: none;
    padding: 1% 0%;
    font-size: 18px;
    font-weight: 500;
}
.me1 {
    width: 50%;
    float: left;
    text-align: center;
}
.me1 img {
    margin-bottom: 7%;
}
.ma ul {
    margin-bottom: 4%;
}

.ma p {     font-size: 18px;
    font-weight: 500;
    margin-left: 20%;
    margin-top: 6%;
}
.ma h2 span {
    color: #ffae00;
    background-color: #f71735;
    background-image: linear-gradient(147deg, #f8754b 0, #ffac03 74%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
.onboard {
     width: 80%;
    margin: 0% auto;
    text-align: center;
    margin-bottom: 5%;
}

.onboard h1 {
    font-size: 39px;
}
.collapse {
    overflow: visible;}
.onboard p {
    font-size: 20px;
    margin-top: 1%;
    margin-bottom: 3%;
}
.onboard span {
    margin-top: 20px;
    display: block;
    color: gray;
    font-size: 16px;
}
ul.nav.navbar-nav.navbar-right {
    display: inline-block;
}
h1 span {
    font-weight: 800 !important;
}
h2 span {
    font-weight: 800 !important;
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-weight: 800;}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 span{
    font-weight: 800;}
body {
    background: transparent !important;
    color: #000;font-family: system-ui;
}
body {
    margin-top: -16px;
}
.unblock_l h2 span {
    color: #ffae00;
    background-color: #f71735;
    background-image: linear-gradient(147deg, #f8754b 0, #ffac03 74%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
.onboard a {
      background: linear-gradient(85deg, #f66a59, #ffae00);
    color: #fff;
    padding: 11px 23px;
    border-radius: 5px;
    text-decoration: none;
    margin-top: 1%;
    display: inline-block;
}
a.btn.gradient-bg img {
    position: absolute;
    left: 7%;
    top: 18%;
    width: 24px;
}
a.btn.gradient-bg {
    background: #000;
    color: #fff;
    padding: 10px 3%;position: relative;
    border-radius: 5px;
    text-decoration: none;
    font-size: 15px;
    margin-right: 5px;
}
.boxa {
    box-shadow: 0px 20px 50px 0px rgb(191 188 188 / 10%);
    background: #f5f5f5;
    padding: 4% 3% 20px;
    margin-bottom: 4%;
    border-radius: 5px;
    border: 1px solid #eee;
}

.boxa p {    margin: 0px;
    display: flex;
    align-items: center;
}
.pack {
    overflow: auto;
    padding-bottom: 5%;
}.inner_pack {
    width: 80%;
    margin: auto;
}.inner_pack h1 {
      text-align: center;
    margin-top: 7%;
    font-size: 51px;
    margin-bottom: 2%;
    font-weight: 800;
}.pack_1 {
    position: relative;
    width: 30%;
    float: left;
    box-shadow: 0 20px 50px rgba(0, 0, 0, .1);
    padding: 2%;
    box-sizing: border-box;
    border-radius: 5px;
    text-align: center;
    margin: 1.5%;
}.pack_1 h2 {
    margin-top: 62px;
    text-transform: uppercase;
}.mrp {
    width: 100%;
    height: 100px;
    margin: auto;
    background: linear-gradient(45deg, rgb(246, 107, 89) 0%, rgb(247, 113, 80) 19%, rgb(251, 143, 41) 72%, rgb(253, 159, 19) 100%);
    border-radius: 10px;
    color: #fff;
    line-height: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    /* box-shadow: 0 20px 50px rgba(0, 0, 0, .1); */
}.mrp b {
    font-size: 40px;
    width: 100% !important;
    display: inline-block;
    margin-top: 22px;
    line-height: 0px;
}.infoa {
    padding: 5% 0% 18%;
}
.center_p .infoa button {
    background: #fff;
    color: #fb8f29;
}
.infoa p {
        text-align: left;
    float: right;
    width: 100%;
    line-height: 21px;
    margin-bottom: 9px;
}.infoa p i {
       margin-right: 3%;
    color: #fa981f;
    float: left;
    height: 27px;
    width: 18px;
}
.infoa button:hover:after {
    display: block;
}
@keyframes  effts1{
    0%{
        transform: translate3d(-109%,-50px,0) rotate3d(0,0,1,45deg);
    }
    50%{
        transform: translate3d(40%,-50px,0) rotate3d(0,0,1,45deg);
    }
    100%{
        transform: translate3d(80%,-50px,0) rotate3d(0,0,1,45deg);
    }
}
@keyframes  effts{
    0%{
        transform: translate3d(-109%,-50px,0) rotate3d(0,0,1,75deg);
    }
    50%{
        transform: translate3d(40%,-50px,0) rotate3d(0,0,1,75deg);
    }
    100%{
        transform: translate3d(80%,-50px,0) rotate3d(0,0,1,75deg);
    }
}
.infoa button:after {
    content: '';
    position: absolute;
    display: none;
    width: 200px;
    height: 100px;
    -webkit-transform: translate3d(-109%, -50px, 0) rotate3d(0, 0, 1, 45deg);
    -ms-transform: translate3d(-109%, -50px, 0) rotate3d(0, 0, 1, 45deg);
    transform: translate3d(63%, -58px, 0) rotate3d(0, 0, 1, 45deg);
    transition: all 1.1s cubic-bezier(.19,1,.22,1);
    background: rgba(255, 255, 255, .5);
    left: 0;
    top: 0;
    animation: effts1 1s infinite;
}
.tooltip {
    background: #f97d40;
    width: 16px;
    display: inline-block !important;
    height: 16px;
    text-align: center;
    color: #fff !important;
    border-radius: 50px;
}.infoa button {
    background: linear-gradient(45deg, rgb(246, 107, 89) 0%, rgb(247, 113, 80) 19%, rgb(251, 143, 41) 72%, rgb(253, 159, 19) 100%);
    color: #fff;
    border: 0px;
    overflow: hidden;
    padding: 8px 5% 10px;
    border-radius: 50px;
    position: relative;
    margin-top: 6%;
    width: 62%;
    text-transform: uppercase;
    font-size: 17px;
}
@keyframes  efftsp{
    0%{
       transform: rotate(20deg);
    }
    50%{
       transform: rotate(30deg);
    }
    100%{
       transform: rotate(15deg);
    }
}
.thumb_i {
       width: 47px;
    position: absolute;
    right:30px;
    bottom: -6px;
    animation: efftsp 1s infinite;
}
.mrp p {
    color: #000;
    margin-top: 9px;
    padding: 5px;
    width: 100%;
    border-radius: 5px;
    font-size: 23px;
    margin: auto;
    margin-top: 2px;
    font-weight: 600;
    position: relative;
    text-align: left;
    padding-left: 12%;
}
.mame {    float: left;
    position: relative;
    background-color: #fff;
    border: 1px solid #ffdcc8;
    box-shadow: 5px 9px 11px -1px #585b631a;
    border-radius: 16px;
    height: calc(100% - 30px);
    margin-bottom: 30px;
    padding: 30px;
    box-sizing: border-box;
    transition: all 0.4s ease-in-out;
    overflow: hidden;
    cursor: none;
    width: 31%;
    margin: 1%;
}.mame {
    box-shadow: none;
}
.container1 {
    width: 90%;
    overflow: visible;
}.four {
    padding: 2%;
}.in_four p {
    font-size: 20px;
}
.icon-box {
    position: relative;
    z-index: 2;
    margin-bottom: 10px;
}
.service-item::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    border-radius: 0px;
    background: linear-gradient(180deg, #f66a59 0%, #ffae00 100%);
    transition: all 0.4s ease-in-out;
    height: 100%;
    z-index: 1;
}
.service-item:hover .icon-box img {
    filter: brightness(0) invert(1);
}
.service-item:hover:before {
    top: 0;
}.service-item:hover .service-body h3 {
    color: #ffffff;
}.service-item:hover .service-body p {
    color: #ffffff;
}
.icon-box img {
    transition: all 0.4s ease-in-out;
}
.icon-box {
    text-align: center;
}
.service-body {
    position: relative;
    z-index: 2;
    margin-bottom: 20px;
    text-align: center;
}

.service-body h3 {
    font-size: 20px;
    font-weight: 600;
    text-transform: capitalize;
    margin-bottom: 20px;
    transition: all 0.3s ease-in-out;
}
body {
    padding-bottom: 0px !important;
}
.service-body p {
    margin: 0;
    transition: all 0.3s ease-in-out;
    color: #757575;
    line-height: 28px;
}
.pack_1.center_p .mrp {
    background: #fff;
    color: #fb8f29;
    height: 134px;
}.pack_1.center_p {
    background: linear-gradient(45deg, rgb(246, 107, 89) 0%, rgb(247, 113, 80) 19%, #fb8f29 72%, rgb(253, 159, 19) 100%);
    color: #fff;
}

.pack_1.center_p .infoa i {
    color: #fff;
}
@media(max-width: 768px){
    section.accordion.accordion--radio {
    padding: 10% 0%;
}
    .container1 {
        width: 100%!important;
        padding: 6%;
    }
    .left_a {
            width: 100%;
        margin-top:30px;
}a.btn.gradient-bg img {
    position: absolute;
    left: 2%;
    top: 31%;
    width: 15px;
}.left_a span {
    margin-left: 0px !important;
}
.tab input {
    width: auto;
}
button.navbar-toggle {
    display: block;
}
.left_a h1 {
    font-size: 30px;
    line-height: 34px;
}

.left_b {        width: 100%;
        margin-top: 40px;
}
.s_flex.s_align-center.s_home-hero-left-btn {
    width: 100%;
}
.s_efficiency-img {
        position: relative;
        width: 315px;
        height: 315px;
        margin-left: 4px;
}
.left_b img {
    width: 100%;
}
span.icon-bar {
    width: 22px;
    height: 2px;
    display: block;
    margin-top: 3px;
    background: #000!important;
}button.navbar-toggle {
    position: absolute;
    z-index: 99999999;
    right: 0%;
}

button.navbar-toggle {
   background: transparent;
        border: 1px;
        float: right;
        margin: 14px 30px;
}

.navbar-header {
    width: 100%;
}
.ban {
    padding-top: 88px;
}

a.tally {
    font-size: 14px;
}

.in_two h1 {
    font-size: 25px;
}

.in_three h1 {
    font-size: 25px;
}

.mame {
    width: 99%;
}

.in_four h1 {
    font-size: 25px;
}

.in_four {
    width: 100%;
}

.in_five {
    width: 98%;
}

.a1 p {
    font-size: 12px;
}

.a p {
    width: 70%;
    font-size: 14px;
}

img.image-103 {
    width: 30px;
    height: 30px;
    margin: 0px;
}

.a2 {
    width: 58px;
}

.a2 img {
    width: 17px;
}
.five a {
    width: 42%;
}

.in_re h1 {
    font-size: 25px;
}

.in_unblock h1 {
    font-size: 25px;
    line-height: 31px;
}

.unblock_l {
    width: 100%;
}

.unblock_l h2 {
    font-size: 25px;
    margin-top: 17px;text-align: center;
}
.three {
    width: 100%;
        overflow: visible;
        padding: 0px !important;
}
.in_two h1 span{font-size: 25px;}
.unblock_r {
    width: 100%;
    text-align: center;
    margin: auto;
    float: left;
}

.unblock_r img {
    float: none;
}

.witha h2 {
    font-size: 25px;
    line-height: 30px;
}

.me1 {
    width: 100%;
}

.me1 img {
    width: 100%;
}

.ma {
    width: 100%;
    padding-left: 0px;
    margin-top: 34px;
}

.six_l h1 {
    font-size: 25px;
}

.six_l {
    width: 100%;
    padding-left: 0px;
}

.in_six {
    padding: 7% 4%;
}

.six_r {
    width: 100%;
}

.first.mt {
    width: 100%;
}

.inner_pack h1 {
    font-size: 25px;
}

.pack_1 {
    width:98%;
}

.secure_r h1 {
    font-size: 25px;
}

.in_Seven {
    width: 98%;
}

section.accordion.accordion--radio h3 {
    font-size: 25px;
}

section.accordion.accordion--radio {
    width: 88%;
}
.tab label {
    font-size: 13px;
}
section.accordion.accordion--radio {}
.seven {
    overflow: hidden;
    background: #e9ebf9;
    padding: 11% 6% 8%;
    color: #000;
}
.s_col-7 {
    width: 100%;
}
a, p, span, div, li, td {
    font-weight: 400 !important;
    font-size: 17px;
}
.secure_r p {
    font-size: 17px;
}
.s_efficiency-bg {
    padding: 6%;
        width: 98%;
        margin: auto;
        box-sizing: border-box;
}
.s_col-5 {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
.s_efficiency-content h4 {
    font-size: 25px;
    margin-top: 0px!important;
}

.s_efficiency-content {
    margin-top: 1px;
}

section.s_efficiency {
    padding: 3px;
}
ul.nav.navbar-nav.navbar-right {
    display: none;
}
.s_col-5 {
    width: 100%;
    margin-top: 50px;
}
.a1 {
    align-items: center;
    justify-content: flex-start;
}
ul.nav.navbar-nav.navbar-right {
    display: none;
        width: 106%;
        position: fixed;
        background: #fff;
        top: 0%;
        z-index: 999999;
        height: 100%;
        left: 0%;
        padding: 7%;
}.navbar-nav li.sho a {
    color: #fff !important;
}
a.btn.red-bg.aa {
    background: linear-gradient(85deg, #f66a59, #ffae00);
    border: 0px !important;
}
.navbar-nav li a {
    color: #000000 !important;}
.navbar-nav li {
    display: block;
    margin-top: 12px;
}
.a2 {
    display: none;
}
.parent {
    display: block;
}

.first.mt {
    box-sizing: border-box;
    margin-top: 5%;
}

.first {
    width: 100%;
    box-sizing: border-box;
    margin-top: 0px;
}
.inner_pack {
    width: 100%;
        margin: auto;
        margin: auto;
        text-align: center;
        overflow: hidden;
        padding: 6%;
}
.pack_1 {
   
    padding: 6%;
   
    margin-bottom: 10%;
}
.m {
    box-sizing: border-box;
    width: 100%;
}
.in_re {
    text-align: center;
    width: 96%;}
.navbar.navbar-nobg {
    padding: 0px !important;
}
.repotsa img {
    position: relative;
        left: 0%;
        top: 0%;width: 100%;
        margin-bottom: 8%;
}
a.navbar-brand img {
    width: 140px;
}.repotsa {
    height: auto;width: 80%;
}
.unblock_l h2 span {
    font-size: 25px;
    text-align: center;
}
a.navbar-brand {
    padding: 0px;
}
.six_r {
    margin-top: 6%;
}
.a1 img {
    display: none;
}
.navbar-nav a.btn {
    margin-left: 14px;
}
}

    
</style>
 
